import {DeployConfigFile} from '../components/TestDeployView/useDeploy';

const getImageFileMetadata = (file: File): Promise<DeployConfigFile> =>
  new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const {naturalWidth: width, naturalHeight: height} = img;
      resolve({
        file,
        metadata: {
          width,
          height,
        },
      });
    };
    img.onerror = () => {
      resolve({file, metadata: {width: 0, height: 0}});
    };

    img.src = URL.createObjectURL(file);
  });

export default getImageFileMetadata;
